import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditLevelComp from "./Component/EditLevelComp"


const EditLevel =()=>{
    return(
        <>
       
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditLevelComp />
        </div>
        <Footer />
        </>
    )
}

export default EditLevel